import { baseApi } from "@/services/base-api";
import type { AppNotification } from "@/features/engagement/types/notification";

export interface NotificationsFilters {
  filter?: "unread";
  page?: number;
}

/**
 * docs/architecture/authentication.md lists `GET /notifications` as
 * protected. `getUnreadCount` is a separate, lightweight endpoint rather
 * than deriving the bell badge from the full list — the badge renders on
 * every authenticated page (`AuthenticatedLayout`'s header), and shouldn't
 * force a full notification-list fetch just to show a number.
 */
export const notificationsApi = {
  getNotifications: (filters: NotificationsFilters = {}) =>
    baseApi.getPaginated<AppNotification>("/notifications", { params: filters }),

  getUnreadCount: () => baseApi.get<{ count: number }>("/notifications/unread-count"),

  markAsRead: (id: string) => baseApi.patch<void>(`/notifications/${id}/read`),

  markAllAsRead: () => baseApi.patch<void>("/notifications/read-all"),
};
